import {
    DEMANDEUR_SIGNATURE_SLICE_NAME,
    DOSSIER_SIGNATURE_SLICE_NAME,
    SIGNATURE_REDUCER_NAME,
} from './constants';
import { SignStateType } from './types';

export const DossierSignatureSelector = (s: SignStateType) =>
    s[SIGNATURE_REDUCER_NAME][DOSSIER_SIGNATURE_SLICE_NAME];

export const DemandeurSignatureSelector = (s: SignStateType) =>
    s[SIGNATURE_REDUCER_NAME][DEMANDEUR_SIGNATURE_SLICE_NAME];

export const MainDossierSignatureSelector = (s: SignStateType) =>
    s[SIGNATURE_REDUCER_NAME][DOSSIER_SIGNATURE_SLICE_NAME].main;

export const MainDemandeurSignatureSelector = (s: SignStateType) =>
    s[SIGNATURE_REDUCER_NAME][DEMANDEUR_SIGNATURE_SLICE_NAME].main;
